import { useEffect, useState, lazy, Suspense } from 'react'
import { useLayoutVisibility } from '@context/LayoutContext'
import { useMemorama } from '../../context/MemoramaContext'
import { getPlayersRanking, Podium } from '@shared'
import { useLanguage } from '@context/LanguageContext'
import { useTheme } from '@context/ThemeContext'
import { useAnimations } from '@context/AnimationsContext'
import { cx } from '@utils/cx'
import SinglePlayerSummary from '../ui/SinglePlayerSummary'
import MemoramaEndModal from '../ui/MemoramaEndModal'
import styles from './MemoramaEnd.module.css'

const Confetti = lazy(() => import('@shared/components/effects/Confetti.jsx'))
const Fireworks = lazy(() => import('@shared/components/effects/Fireworks.jsx'))

export default function MemoramaEnd () {
  useLayoutVisibility({ header: false, footer: false })

  const { players } = useMemorama()
  const { t } = useLanguage()
  const { theme } = useTheme()
  const { animationsEnabled } = useAnimations()
  const [showEffects, setShowEffects] = useState(false)
  const [showFinalModal, setShowFinalModal] = useState(false)
  const ranking = getPlayersRanking(players)
  const title = players.length === 1
    ? t.memorama.end.titleSingle
    : t.memorama.end.titleMulti

  useEffect(() => {
    const isSinglePlayer = players.length === 1
    const timers = []

    if (!animationsEnabled) {
      // Skip animation delays entirely
      setShowEffects(false)
    } else {
      timers.push(setTimeout(() => setShowEffects(true), isSinglePlayer ? 1500 : 5900))
    }

    timers.push(setTimeout(() => setShowFinalModal(true), 8500))

    return () => timers.forEach(clearTimeout)
  }, [players, animationsEnabled])

  if (!players || players.length === 0) {
    return <p>{t.memorama.end.noPlayers}</p>
  }

  const isSinglePlayer = players.length === 1

  return (
    <div className={styles.endScreen}>
      <h1
        className={cx(
          styles.title,
          isSinglePlayer ? styles.titleSlow : styles.titleFast
        )}
      >
        {title}
      </h1>

      {isSinglePlayer
        ? <SinglePlayerSummary />
        : <Podium players={ranking} />}

      {showEffects && (
        <Suspense fallback={null}>
          {(theme === 'light' || isSinglePlayer) && <Confetti />}
          {theme === 'dark' && !isSinglePlayer && <Fireworks />}
        </Suspense>
      )}

      {showFinalModal && (
        <MemoramaEndModal />
      )}

    </div>
  )
}
